export default class CACA1130RequestModel {
  productNo: string
  shhnCd: string
}
